export enum SlideType {
  image = 'image',
  video = 'video',
}

export type ESlideType = `${SlideType}`

export interface CarouselSlide {
  src: string
  alt: string
  type: ESlideType
  caption: string
}

export type SliderAction =
  | { type: 'UPDATE_SLIDE'; payload: { newSlide: number } }
  | { type: 'UPDATE_TOTAL'; payload: { totalSlides: number } }

export interface SliderState {
  currentSlide: number
  prevSlide: number | undefined
  nextSlide: number | undefined
  totalSlides: number
}
